<template>
  <v-container>
    <v-layout>
      <lorem-ipsum />
    </v-layout>
  </v-container>
</template>

<script>
import LoremIpsum from '@/components/LoremIpsum.vue';

export default {
  name: 'blog',
  components: { LoremIpsum },
};
</script>
